import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { AgentService } from '../agent.service';
import * as agentActions from './agent.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Agent } from '../../_models/agent';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';

@Injectable()
export class AgentEffects {

    @Effect()
    loadAgent$ = this.actions$.pipe(
        ofType(agentActions.AgentActitonTypes.LoadAgents),
        mergeMap((action: agentActions.LoadAgents) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadAgents =');
                // console.log(action.payload);

                return this.agentService.getAgents(action.payload).pipe(
                    map((agents: Agent[]) => {
                        this.changingLoading(false);
                        return new agentActions.LoadAgentsSuccess(agents);
                    }),
                    catchError(err => of(new agentActions.LoadAgentsFail(err)))
                )
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadAgentSuccess$ = this.actions$.pipe(
    //     ofType(agentActions.AgentActitonTypes.LoadAgentsSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateAgent$: Observable<Action> = this.actions$.pipe(
    //     ofType(agentActions.AgentActitonTypes.UpdateAgent),
    //     map((action: agentActions.UpdateAgent) => action.payload),
    //     mergeMap(( agent: Agent) =>
    //         this.agentService.updateAgent(agent).pipe(
    //         map(updatedAgent => (new agentActions.UpdateAgentSuccess(updatedAgent))),
    //         catchError(err => of(new agentActions.UpdateAgentFail(err)))
    //     ))
    // );

    @Effect()
    updateAgent$ = this.actions$.pipe(
        ofType(agentActions.AgentActitonTypes.UpdateAgent),
        mergeMap((action: agentActions.UpdateAgent) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateAgent =');
                // console.log(action.payload);

                return this.agentService.updateAgent(action.payload).pipe(
                    map((agent: Agent) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateAgent =');
                        console.log(agent);
                        if (agent !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/agent', null, 'info');
                            return new agentActions.UpdateAgentSuccess(agent);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new agentActions.UpdateAgentFail('ERROR UpdateAgent effect.');
                        }
                    }),
                    catchError(err => of(new agentActions.UpdateAgentFail(err)))
                )
            }
        )
    );


    // @Effect()
    // createAgent$: Observable<Action> = this.actions$.pipe(
    //     ofType(agentActions.AgentActitonTypes.CreateAgent),
    //     map((action: agentActions.CreateAgent) => action.payload),
    //     mergeMap(( agent: Agent) =>
    //         this.agentService.createAgent(agent).pipe(
    //         map(createAgent => (new agentActions.CreateAgentSuccess(createAgent))),
    //         catchError(err => of(new agentActions.CreateAgentFail(err)))
    //     ))
    // );

    @Effect()
    CreateAgent$ = this.actions$.pipe(
        ofType(agentActions.AgentActitonTypes.CreateAgent),
        mergeMap((action: agentActions.CreateAgent) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateAgent =');
                // console.log(action.payload);

                return this.agentService.createAgent(action.payload).pipe(
                    map((agent: Agent) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateAgent =');
                        // console.log(agent);
                        if (agent !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/agent', null, 'info');
                            return new agentActions.CreateAgentSuccess(agent);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new agentActions.CreateAgentFail('ERROR CreateAgent effect.');
                        }
                    }),
                    catchError(err => of(new agentActions.CreateAgentFail(err)))
                )
            }
        )
    );

    // @Effect()
    // deleteAgent$: Observable<Action> = this.actions$.pipe(
    //     ofType(agentActions.AgentActitonTypes.DeleteAgent),
    //     map((action: agentActions.DeleteAgent) => action.payload),
    //     mergeMap(( agent: Agent) =>
    //         this.agentService.deleteAgent(agent).pipe(
    //         map(deleteAgentId => (new agentActions.DeleteAgentSuccess(deleteAgentId))),
    //         catchError(err => of(new agentActions.DeleteAgentFail(err)))
    //     ))
    // );

    @Effect()
    deleteAgent$ = this.actions$.pipe(
        ofType(agentActions.AgentActitonTypes.DeleteAgent),
        mergeMap((action: agentActions.DeleteAgent) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteAgent =');
                // console.log(action.payload);

                return this.agentService.deleteAgent(action.payload).pipe(
                    map((agentId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteAgent =');
                        console.log(agentId);
                        if (agentId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new agentActions.DeleteAgentSuccess(agentId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new agentActions.DeleteAgentFail('ERROR DeleteAgent effect.');
                        }
                    }),
                    catchError(err => of(new agentActions.DeleteAgentFail(err)))
                )
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private agentService: AgentService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Agent Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
